import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: [],
    dataCompletadas: [],
    detalleEntrega: [],
    catalogoMaguey: [],
}

//types
const ENTREGAS_SOLICITUDES_EXITO = 'ENTREGAS_SOLICITUDES_EXITO'
const ENTREGAS_SOLICITUDES_COMPLETADAS_EXITO = 'ENTREGAS_SOLICITUDES_COMPLETADAS_EXITO'
const ENTREGAS_DETALLE_09_EXITO = 'ENTREGAS_DETALLE_09_EXITO'
const ENTREGAS_DETALLE_33_EXITO = 'ENTREGAS_DETALLE_33_EXITO'
const ENTREGAS_DETALLE_41_EXITO = 'ENTREGAS_DETALLE_41_EXITO'
const GENERAR_RECIBO_EXITO = 'GENERAR_RECIBO_EXITO'
const CATALOGO_MAGUEY_EXITO = 'CATALOGO_MAGUEY_EXITO'
const AGREGAR_INFORMACION_ENTREGA_EXITO = 'AGREGAR_INFORMACION_ENTREGA_EXITO'
const ACTUALIZAR_INFORMACION_ENTREGA_EXITO = 'ACTUALIZAR_INFORMACION_ENTREGA_EXITO'
const ACTUALIZAR_FC_09_EXITO = 'ACTUALIZAR_FC_09_EXITO'
const ACTUALIZAR_FC_33_EXITO = 'ACTUALIZAR_FC_33_EXITO'
const ACTUALIZAR_FC_41_EXITO = 'ACTUALIZAR_FC_41_EXITO'
const OBTENER_FOLIO_HOLOGRAMA_OFICIO = 'OBTENER_FOLIO_HOLOGRAMA_OFICIO'
const ACTUALIZAR_FOLIO_HOLOGRAMA_OFICIO = 'ACTUALIZAR_FOLIO_HOLOGRAMA_OFICIO'
const AGREGAR_MAGUEYES_INFO_PRODUCTO = 'AGREGAR_MAGUEYES_INFO_PRODUCTO'
const ELIMINAR_MAGUEY_INFO_PRODUCTO = 'ELIMINAR_MAGUEY_INFO_PRODUCTO'

export const obtenerSolicitudesEntregas = createAsyncThunk(
    ENTREGAS_SOLICITUDES_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloEntregas/ObtenerSolicitudesEntregas`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSolicitudesEntregasCompletadas = createAsyncThunk(
    ENTREGAS_SOLICITUDES_COMPLETADAS_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloEntregas/ObtenerSolicitudesEntregasCompletados`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDetalleFC_09 = createAsyncThunk(
    ENTREGAS_DETALLE_09_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloEntregas/obtenerFormatoFC09_ConDetalle/${id}`
            const res = await axios.get(fullUrl)
            res.data.data.formato = 'FC_09'
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDetalleFC_33 = createAsyncThunk(
    ENTREGAS_DETALLE_33_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloEntregas/obtenerFormatoFC33_ConDetalle/${id}`
            const res = await axios.get(fullUrl)
            res.data.data.formato = 'FC_33'
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDetalleFC_41 = createAsyncThunk(
    ENTREGAS_DETALLE_41_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloEntregas/obtenerFormatoFC41_ConDetalle/${id}`
            const res = await axios.get(fullUrl)
            res.data.data.formato = 'FC_41'
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarReciboHolograma = createAsyncThunk(
    GENERAR_RECIBO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `ModuloEntregas/generarReciboHologramas`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const AgregarInformacionEntrega = createAsyncThunk(
    AGREGAR_INFORMACION_ENTREGA_EXITO,
    async (data) => {
        try {
            const fullUrlInfo = host + `ModuloEntregas/agregarInformacionEntregaHologramas`
            const fullUrlEntrega = host + `ModuloEntregas/agregarEntregasHologramas`
            const fullUrlProducto = host + `ModuloEntregas/agregarInformacionProdutoHologramas`
            const fullUrl = host + `ModuloEntregas/generarReciboHologramas`
            const fullUrlMagueyesSeleccionados = host + `ModuloEntregas/agregarMagueyesInfoProductoHologramas`

            const res = await axios.post(fullUrlInfo, { data: data?.informacionentregahologramas })
            let dataEntrega = {
                idinformacionentrega: res?.data?.data?.idinformacionentrega, fecha: data.object?.fecha,
                hologramassolcitados: data?.object?.hologramassolcitados?.toString(), hologramasentregados: data?.object?.hologramasentregados?.toString(),
                folioinicial: data?.object?.folioinicial,
                foliofinal: data?.object?.foliofinal,
                restante: data?.object?.restante?.toString(),
                inventariofinal: data?.object?.inventariofinal?.toString(),
                prefijo: data?.object?.prefijo
            }
            const resEntrega = await axios.post(fullUrlEntrega, { data: dataEntrega })

            data.informacionRecibo.identrega = resEntrega?.data?.data?.identrega
            await axios.post(fullUrl, { data: data?.informacionRecibo })

            for (const i in data?.productos) {
                let producto = data?.productos?.[i]
                let dataProducto = {}
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_09') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc09_solicitudcertificado: data?.informacionentregahologramas?.idfc09_solicitudcertificado, idproducto: producto.idproducto
                }
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_33') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc33_solicitudenvasadonaciona: data?.informacionentregahologramas?.idfc33_solicitudenvasadonaciona, idproducto: producto.idproducto
                }
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_41') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc41_solicitudparabebidasconm: data?.informacionentregahologramas?.idfc41_solicitudparabebidasconm, idproducto: producto.idproducto
                }
                let productoss = await axios.post(fullUrlProducto, { data: dataProducto })
                for (const p in producto?.magueyesSeleccionados) {
                    let magueyes = {
                        idproductoholograma: Number(productoss.data?.data?.idproductoholograma),
                        idmaguey: Number(producto.magueyesSeleccionados[p])
                    }
                    await axios.post(fullUrlMagueyesSeleccionados, { data: magueyes })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const ActualizarInformacionEntrega = createAsyncThunk(
    ACTUALIZAR_INFORMACION_ENTREGA_EXITO,
    async (data) => {
        try {
            const fullUrlInfo = host + `ModuloEntregas/actualizarInformacionEntregaHologramas`
            const fullUrlEntrega = host + `ModuloEntregas/agregarEntregasHologramas`
            const fullUrlProducto = host + `ModuloEntregas/actualizarInformacionProdutoHologramas`
            const fullUrl = host + `ModuloEntregas/generarReciboHologramas`
            const fullUrlMagueyesSeleccionados = host + `ModuloEntregas/agregarMagueyesInfoProductoHologramas`
            const res = await axios.put(fullUrlInfo, { data: data?.informacionentregahologramas })
            let dataEntrega = {
                idinformacionentrega: res?.data?.data?.idinformacionentrega, fecha: data.object?.fecha,
                hologramassolcitados: data?.object?.hologramassolcitados?.toString(), hologramasentregados: data?.object?.hologramasentregados?.toString(),
                folioinicial: data?.object?.folioinicial,
                foliofinal: data?.object?.foliofinal,
                restante: data?.object?.restante?.toString(),
                inventariofinal: data?.object?.inventariofinal?.toString(),
                prefijo: data?.object?.prefijo
            }
            let resEntrega = await axios.post(fullUrlEntrega, { data: dataEntrega })

            data.informacionRecibo.identrega = resEntrega?.data?.data?.identrega
            await axios.post(fullUrl, { data: data?.informacionRecibo })

            for (const i in data?.productos) {
                let producto = data?.productos?.[i]
                let dataProducto = {}
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_09') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc09_solicitudcertificado: data?.informacionentregahologramas?.idfc09_solicitudcertificado, idproducto: producto.idproducto,
                    idproductoholograma: producto.idproductoholograma
                }
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_33') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc33_solicitudenvasadonaciona: data?.informacionentregahologramas?.idfc33_solicitudenvasadonaciona, idproducto: producto.idproducto,
                    idproductoholograma: producto.idproductoholograma
                }
                if (data?.informacionentregahologramas?.tiposolicitud == 'FC_41') dataProducto = {
                    idinformacionentrega: res?.data?.data?.idinformacionentrega, categoria: producto?.categoria,
                    clase: producto?.clase, estado: producto?.estado, destino: producto?.destino, tipoproducto: data?.informacionentregahologramas?.tiposolicitud,
                    idfc41_solicitudparabebidasconm: data?.informacionentregahologramas?.idfc41_solicitudparabebidasconm, idproducto: producto.idproducto,
                    idproductoholograma: producto.idproductoholograma
                }
                let resproducto = await axios.put(fullUrlProducto, { data: dataProducto })
                const fullUrlDeleteMaguey = host + `ModuloEntregas/eliminarMagueyInfoProductoHologramas/${resproducto.data?.data?.idproductoholograma}`
                await axios.delete(fullUrlDeleteMaguey)
                for (const p in producto?.magueyesSeleccionados) {
                    let magueyes = {
                        idproductoholograma: Number(resproducto.data?.data?.idproductoholograma),
                        idmaguey: Number(producto.magueyesSeleccionados[p])
                    }
                    await axios.post(fullUrlMagueyesSeleccionados, { data: magueyes })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodosCatalogoMaguey = createAsyncThunk(
    CATALOGO_MAGUEY_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `ModuloEntregas/obtenerTodosCatalogoMaguey`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarFC09 = createAsyncThunk(
    ACTUALIZAR_FC_09_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_09/actualizarFC_09SolicitudCertificado`
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarFC33 = createAsyncThunk(
    ACTUALIZAR_FC_33_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_33/actualizarFC_33SolicitudNacional`
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarFC41 = createAsyncThunk(
    ACTUALIZAR_FC_41_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_41/actualizarFormatoFC41`
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFolioHolograma = createAsyncThunk(
    OBTENER_FOLIO_HOLOGRAMA_OFICIO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloEntregas/obtenerFolioOficio/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFolioOficioHolograma = createAsyncThunk(
    ACTUALIZAR_FOLIO_HOLOGRAMA_OFICIO,
    async (data) => {
        try {
            const fullUrl = host + `ModuloEntregas/actualizarFolioOficio`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarMagueyesInfoProductoHologramas = createAsyncThunk(
    AGREGAR_MAGUEYES_INFO_PRODUCTO,
    async (data) => {
        try {
            const fullUrl = host + `ModuloEntregas/agregarMagueyesInfoProductoHologramas`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarMagueyInfoProductoHologramas = createAsyncThunk(
    ELIMINAR_MAGUEY_INFO_PRODUCTO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloEntregas/eliminarMagueyInfoProductoHologramas/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)


export const ModuloEntregasSlice = createSlice({
    name: 'ModuloEntregasSlice',
    initialState: dataInicial,
    reducers: {},
    extraReducers: {
        [obtenerSolicitudesEntregas.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [obtenerSolicitudesEntregasCompletadas.fulfilled]: (state, { payload }) => {
            state.dataCompletadas = payload
        },
        [obtenerDetalleFC_09.fulfilled]: (state, { payload }) => {
            state.detalleEntrega = payload
        },
        [obtenerDetalleFC_33.fulfilled]: (state, { payload }) => {
            state.detalleEntrega = payload
        },
        [obtenerDetalleFC_41.fulfilled]: (state, { payload }) => {
            state.detalleEntrega = payload
        },
        [obtenerTodosCatalogoMaguey.fulfilled]: (state, { payload }) => {
            state.catalogoMaguey = payload
        }
    },
})

export const { } = ModuloEntregasSlice.actions

export const ModuloEntregasReducer = ModuloEntregasSlice.reducer
